import i18n from '@dms/i18n';

import {CO2_CLASS_OPTIONS} from '../constants/CO2_CLASS_OPTIONS';
import {Field} from './primitives/Field';

export function CarbonDioxideEmissionClassWeightedCombinedSelect() {
  return (
    <Field
      type="choice"
      name="carbonDioxideEmissionClassWeightedCombined"
      label={i18n.t('entity.vehicle.labels.carbonDioxideEmissionClassWeightedCombined')}
      options={CO2_CLASS_OPTIONS}
    />
  );
}
